import { jsx as a } from "react/jsx-runtime";
import "react";
import m from "@mui/material/Box";
import { D as p, S as s } from "./shadows-JVyVGdzD.js";
import "@mui/material";
const c = ({ shadowSize: o, children: r, shadowDirection: i = s.BOTTOM, ...t }) => /* @__PURE__ */ a(
  m,
  {
    boxShadow: p[i][o],
    ...t,
    children: r
  }
);
export {
  c as S
};
